export { default as deathScreen } from "./deathScreen";
